module.exports = __webpack_public_path__ + "static/media/6.2dc5f275.png";